export enum ResidentAccessesOnMyhub {
  PremiumServices = "Premium Services",
  LifestyleEvents = "Lifestyle Events",
  Family = "Family",
  Community = "Community",
  DisplayBirthday = "Display birthday in MyHub list",
  Media = "Media",
  News = "News",
  WeatherWidget = "Weather Widget",
  Event = "Event",
  Maintenance = "Maintenance",
  Noticeboard = "Noticeboard",
  Calendar = "Calendar",
  TakePhoto = "Take photo",
  Budget = "Budget",
  VoiceAssistant = "Voice Assistant",
  ResidentEventPictures = "Resident Event Pictures",
  DisplayResidentInCommunityDirectory = "Display Resident In Community Directory"
}